import React, { useState } from "react";
import List from "../reportList";
import Filter from "../reportFilter";
// import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useTranslation } from "react-i18next";
import PATHS from "../../../../constants/paths";
import { useNavigate } from "react-router-dom";
import {
  PageContainer,
  PageHeader,
  NewButton,
  ContentWrapper,
  FilterSection,
  ListSection,
} from "./reportFilterList.styled";

const queryClient = new QueryClient();

const ReportFilterListContainer = (props) => {
  const { t } = useTranslation();
  const [filters, setFilters] = useState(undefined);
  const navigate = useNavigate();

  const handlerCleanFilter = async (resetReport) => {
    resetReport();
    setFilters(undefined);
  };

  // crear reporte
  const goToForm = async () => {
    navigate(PATHS.NEW_REPORT);
  };

  // const handlerOnSubmitFilter = (values) => {
  //   let newFilter = {};
  //   const valuesFilters = Object.entries(values);
  //   valuesFilters.forEach((value) => {
  //     if (value[1] !== undefined && value[1].toString().length > 0) {
  //       newFilter[value[0]] = value[1];
  //     }
  //   });

  //   setFilters(newFilter);
  // };

  const handlerOnSubmitFilter = (values) => {
    let newFilter = {};

    if (values.year) {
      newFilter.year = values.year;
    }

    // InputSelect con optionValue="code" devuelve el código directamente como string
    if (values.department && values.department !== "") {
      newFilter.department = values.department;
    }
    setFilters(newFilter);
  };
  return (
    <PageContainer>
      <ContentWrapper>
        <PageHeader>
          <div className="header-content">
            <div>
              <h1>
                <i className="fa-solid fa-file-lines"></i>
                {t("forms.report.title")}
              </h1>
              {/* <p className="subtitle">
                {t("forms.form.subtitle") || "Manage forms"}
              </p> */}
            </div>
            <NewButton onClick={() => goToForm()}>
              <span className="icon">+</span>
              {t("forms.report.buttons.new")}
            </NewButton>
          </div>
        </PageHeader>

        {/* <FilterSection> */}
        <Filter onSubmit={handlerOnSubmitFilter} onClean={handlerCleanFilter} />
        {/* </FilterSection> */}

        <ListSection>
          <QueryClientProvider client={queryClient}>
            <List filters={filters} />
          </QueryClientProvider>
        </ListSection>
      </ContentWrapper>
    </PageContainer>
  );
};

ReportFilterListContainer.propTypes = {};

export default ReportFilterListContainer;
